import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';

import './styles.css';

const SectionSchedule = ({ theme }) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <section
        id="section-schedule"
        className={theme ? 'dark-mode' : 'light-mode schedule'}
      >
        <div className="de-images">
          <img
            className="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fmtm%2Flarge-Agenda%20Meeting%20The%20Minds%20Libbs.png?alt=media&token=b65d70c7-3ae7-41f0-aac4-a22970000d51"
            width={2000}
            alt=""
          />
        </div>
      </section>
    </>
  );
};

export default SectionSchedule;
